import moment from 'moment';

import {
  getTotalPrice,
} from 'utils/book-rental-items/rentalTotalPrice';
import {
  getAddOns
} from 'utils/book-accommodation-and-activity/prepareBookDataMethods';



const getUnits = (bookItem, currency) => {
  if (!bookItem.availableUnits || !bookItem.availableUnits.length) return {};

  return {
    units: bookItem.availableUnits
      .map(item => {
        if (!item.availableUnits || !parseInt(item.availableUnits)) return;
        let totalPrice = `${item.availableUnits * item[currency]}`;
        return {
          unitsNumber: parseInt(item.availableUnits),
          totalPrice: parseFloat(totalPrice.split(',').join(''))
        };
      })
      .filter(item => item)
  };
};


const getStartingDate = (bookItem) => {
  if (!bookItem) return {};
  
  if (bookItem.multiDates && bookItem.multiDates.startDate) {
    return {
      fromDate: moment(bookItem.multiDates.startDate).format('YYYY-MM-DD'),
      toDate: bookItem.multiDates.endDate 
        ? moment(bookItem.multiDates.endDate).format('YYYY-MM-DD') 
        : moment(bookItem.multiDates.startDate).format('YYYY-MM-DD') 
    };
  } else if (bookItem.startingDate) {
    return {
      fromDate: moment(bookItem.startingDate).format('YYYY-MM-DD'),
      toDate: moment(bookItem.startingDate).format('YYYY-MM-DD') 
    };
  }
  return {};
};

const getTime = bookItem => {
  if (!bookItem.startTime && !bookItem.startingDate && !bookItem.endTime) return {};
  
  if (bookItem.startingDate && bookItem.startTime && bookItem.endTime ) {
    return {
      startTime: moment(bookItem.startTime).toISOString(true),
      endTime:moment(bookItem.endTime).toISOString(true),
    };
  } 
};

const extractInvoiceData = (bookItem) => {

  const availableUnit = bookItem.availableUnits[0];
  
  if (availableUnit.breakdown && Array.isArray(availableUnit.breakdown)) {
    return {
      breakdown: availableUnit.breakdown.map(item => ({
        time: item.hour,
        day: item.day,
        timestamp: item.timestamp,
        price: item.value,
        currency: item.currency,
        type: item.type,
        days: item.days,
        perDayPrice: item.perDayPrice,
        total: item.total,
        pricesType: item.pricesType
      }))
    };
  }
  
  return {
    breakdown: [{
      type: availableUnit.type || bookItem.type,
      days: availableUnit.days || bookItem.days,
      perDayPrice: availableUnit.perDayPrice,
      total: availableUnit[bookItem.currency] || availableUnit.currencyValue,
      currency: bookItem.currency,
      pricesType: availableUnit.pricesType
    }]
  };
};


const getPreparedBookRentalItemsData = (
  rentalItems,
  bookRentalItemsForm,
  isWidget,
  stripeToken,
  payPalOrderId
) => {
  const bookRentalItems = bookRentalItemsForm.values;  
  const adminPlatform = bookRentalItems.platform
    ? bookRentalItems.platform
    : 'Admin panel';
  const platform = isWidget ? 'Widget' : adminPlatform;
  const idObj = bookRentalItems.id ? { id: bookRentalItems.id } : {};
  const paymentIdObj = bookRentalItems.paymentId
    ? { id: bookRentalItems.paymentId }
    : {};

  let paymentType = 'CASH';
  if (stripeToken) paymentType = 'STRIPE';
  if (payPalOrderId) paymentType = 'PAYPAL';

  return {
    rentalItemsBooking: {
      ...idObj,
      rentalItemsId: rentalItems.generalForm.id,
      guestFirstName: bookRentalItems.firstName,
      guestLastName: bookRentalItems.lastName,
      guestPhoneNumber: bookRentalItems.phone,
      guestEmail: bookRentalItems.email,
      platform: platform,
      payment: {
        ...paymentIdObj,
        paymentType: paymentType,
        stripeToken: stripeToken,
        payPalOrderId: payPalOrderId,
        currency: bookRentalItems.currency,
        totalPrice: getTotalPrice(
        rentalItems,
        bookRentalItems.startingDate,
        bookRentalItems.endTime,
        bookRentalItems.startTime,
        bookRentalItems.multiDates,
        bookRentalItems.availableUnits,
        bookRentalItems.addOns,
        bookRentalItems.currency
      )

      },
      ...getStartingDate(bookRentalItems, bookRentalItems.multiDates),
      ...getAddOns(bookRentalItems, bookRentalItems.currency),
      ...getUnits(bookRentalItems,bookRentalItems.currency),
      ...getTime(bookRentalItems,bookRentalItems.startTime,bookRentalItems.endTime),
      ...extractInvoiceData(bookRentalItems,bookRentalItems.currency)
    },
    
  };
};

export { getPreparedBookRentalItemsData };